module.exports = __webpack_public_path__ + "static/img/tutorial_2.a544055.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tutorial_2.png
// module id = 486
// module chunks = 1